export default "__VITE_ASSET__19ebe549__"